import PopupRegister from "../../../../../components/units/Edgecross/Announcement/Popup/Register";

export default function PopupRegisterPage() {
  return <PopupRegister />;
}
